import { Flex } from '@chakra-ui/react'

import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'

export default function LevantamentoDeStatusVacinal() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch } = formMethods

  const tagForQuestion = Object.fromEntries(questions.flatMap((q) => q.tags.map((tag: string) => [tag, q.slug])))

  const vacinaHepatiteB_recebeu = watch ? watch(`form_answers.${tagForQuestion['vacinaHepatiteB_recebeu']}`) : undefined

  const vacinaDifteriaTetano_recebeu = watch
    ? watch(`form_answers.${tagForQuestion['vacinaDifteriaTetano_recebeu']}`)
    : undefined

  const vacinaFebreAmarela_recebeu = watch
    ? watch(`form_answers.${tagForQuestion['vacinaFebreAmarela_recebeu']}`)
    : undefined

  const vacinaTripliceViral_recebeu = watch
    ? watch(`form_answers.${tagForQuestion['vacinaTripliceViral_recebeu']}`)
    : undefined

  const vacinaPneumococica23Valente_recebeu = watch
    ? watch(`form_answers.${tagForQuestion['vacinaPneumococica23Valente_recebeu']}`)
    : undefined

  const vacinaVaricela_recebeu = watch ? watch(`form_answers.${tagForQuestion['vacinaVaricela_recebeu']}`) : undefined

  const vacinaInfluenzaTrivalente_recebeu = watch
    ? watch(`form_answers.${tagForQuestion['vacinaInfluenzaTrivalente_recebeu']}`)
    : undefined

  const vacinaCovid19_recebeu = watch ? watch(`form_answers.${tagForQuestion['vacinaCovid19_recebeu']}`) : undefined

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        //Hepatite B
        if (
          question.tags.includes('vacinaHepatiteB_doses') ||
          question.tags.includes('vacinaHepatiteB_dataUltimaDose')
        ) {
          if (vacinaHepatiteB_recebeu === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        // Difteria e Tétano
        if (
          question.tags.includes('vacinaDifteriaTetano_doses') ||
          question.tags.includes('vacinaDifteriaTetano_dataUltimaDose')
        ) {
          if (vacinaDifteriaTetano_recebeu === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        // Febre Amarela
        if (question.tags.includes('vacinaFebreAmarela_dataUltimaDose')) {
          if (vacinaFebreAmarela_recebeu === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        // Tríplice Viral
        if (
          question.tags.includes('vacinaTripliceViral_doses') ||
          question.tags.includes('vacinaTripliceViral_dataUltimaDose')
        ) {
          if (vacinaTripliceViral_recebeu === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        // Pneumocócica 23-valente
        if (question.tags.includes('vacinaPneumococica23Valente_doses')) {
          if (vacinaPneumococica23Valente_recebeu === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        // Varicela
        if (question.tags.includes('vacinaVaricela_doses')) {
          if (vacinaVaricela_recebeu === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        // Influenza Trivalente
        if (question.tags.includes('vacinaInfluenzaTrivalente_dataUltimaDose')) {
          if (vacinaInfluenzaTrivalente_recebeu === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        // COVID 19
        if (question.tags.includes('vacinaCovid19_dataUltimaDose')) {
          if (vacinaCovid19_recebeu === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
